<!-- 激励页面 -->
<template>
  <div style="background: #eee">
    <van-sticky>
      <van-nav-bar
        title="关联订单详情"
        left-text="返回"
        left-arrow
        @click-left="goback"
      />
    </van-sticky>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      offset="300"
      @load="onLoad"
    >
      <van-cell-group
        v-for="(item, index) in orderList"
        :key="index"
        style="margin: 1.2rem; text-align: left"
        inset
      >
        <div style="font-size: 1.6rem; padding-top: 2rem; text-align: center">
          {{ item.brandIdStr }}
        </div>
        <van-field
          label="车型"
          :value="item.carModelIdStr"
          input-align="right"
          readonly
          label-width="6rem"
        />
        <van-field
          label="主机订单号"
          :value="item.mainOrderNo"
          input-align="right"
          readonly
          label-width="5rem"
        />
        <van-field
          label="上游订单号"
          :value="item.upstreamOrderNo"
          input-align="right"
          readonly
          label-width="5rem"
        />
        <van-field
          label="客户名称"
          :value="item.customerName"
          input-align="right"
          readonly
          label-width="5rem"
        />
        <van-field
          label="联系方式"
          :value="item.contactInfo"
          input-align="right"
          readonly
          label-width="5rem"
        />
        <van-field
          label="车架号"
          :value="item.vin"
          input-align="right"
          readonly
          label-width="5rem"
        />
        <van-field
          label="安装师傅"
          :value="item.installerIdStr"
          input-align="right"
          readonly
          label-width="5rem"
        />
        <van-field
          label="安装费用"
          :value="item.installFee"
          input-align="right"
          readonly
          label-width="5rem"
        />
        <van-field
          label="备注"
          :value="item.remarks"
          input-align="right"
          type="textarea"
          autosize
          rows="1"
          readonly
          label-width="5rem"
        />
        <!-- <van-field
          label="来源"
          :value="item.source? '导入' : '手动新建'"
          input-align="right"
          readonly
          label-width="5rem"
        /> -->
        <van-field
          label="创建时间"
          :value="item.createTime"
          input-align="right"
          readonly
          label-width="5rem"
        />
        <van-field
          label="创建人"
          :value="item.createdByStr"
          input-align="right"
          readonly
          label-width="5rem"
        />
        <van-field
          label="修改时间"
          :value="item.updateTime"
          input-align="right"
          readonly
          label-width="5rem"
        />
        <van-field
          label="修改人"
          :value="item.updatedByStr"
          input-align="right"
          readonly
          label-width="5rem"
        />
      </van-cell-group>
    </van-list>
  </div>
</template>
<script>
export default {
  name: "InstallPage",
  data() {
    return {
      loading: false,
      finished: false,
      orderList: [],
    };
  },
  methods: {
    goback() {
      //返回上一页
      this.$router.go(-1);
    },
    onLoad() {
      this.finished = false;
      this.getPageData();
    },
    getPageData() {
      //获取分页数据
      this.axios({
        url:'/pending-settlement-order/listBySettlementBatchName',
        method: "post",
        data:{
            page:0,
            size:0,
            queryInfoParams: {
                settlementBatchName: this.$route.query.settlementBatchName,
                relatedOrderIds: this.$route.query.relatedOrderIds,
                responsibleUserId: this.$route.query.responsibleUserId,
            }
        }
      }).then(res=>{
        // 处理 relatedOrderIds，可能是逗号分隔的字符串，如 "5,6" 或单个ID "5"
        const relatedOrderIds = this.$route.query.relatedOrderIds;
        if (relatedOrderIds) {
          // 将字符串按逗号分割并转换为数字数组
          const idArray = relatedOrderIds.split(',').map(id => Number(id.trim()));
          // 过滤出匹配的订单
          this.orderList = res.data.data.list.filter(item => idArray.includes(Number(item.id)));
        } else {
          this.orderList = [];
        }
        this.loading = false;
        this.finished = true;
      })
    },
  },
};
</script>
